// PaginaMenu.tsx
import React, { useState, useEffect } from 'react';
import { getAllBuiltMenusByLocalIdV2 } from '../../../../crud/menu_api/menus';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import MenuDisplayer from './components/MenuDisplayer/MenuDisplayer';
import MPPageTitle from '../../../../components/ui/PageTitle/PageTitle';
import { MenuType } from './types/menu.types';

const PaginaMenu: React.FC = () => {
  const [selectedMenu, setSelectedMenu] = useState<MenuType | null>(null);
  const [menus, setMenus] = useState<MenuType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const refreshMenus = async () => {
    setLoading(true);
    const userContext = localStorage.getItem('user');
    const localId = userContext ? JSON.parse(userContext).local_id : 0;
    getAllBuiltMenusByLocalIdV2(localId, 'All')
      .then((response) => {
        const fetchedMenus = response.data;
        setMenus(fetchedMenus);
      })
      .catch((error) => {
        console.error('Failed to fetch menus:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    refreshMenus();
  }, []);

  if (loading) {
    return <LoadingSpinner text="Cargando Menú" transparent={true} />;
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Menús</MPPageTitle>
      <MenuDisplayer
        menus={menus}
        setMenus={setMenus}
        selectedMenu={selectedMenu}
        refreshMenus={refreshMenus}
        setSelectedMenu={setSelectedMenu}
      />
    </div>
  );
};

export default PaginaMenu;
